import classNames from 'classnames';
import React from 'react';

export interface BackgroundProps {
  type?: 'full' | 'partial';
  className?: string;
  style?: React.CSSProperties | undefined;
}

export const Background: React.FC<BackgroundProps> = ({
  type = 'full',
  className = '',
  ...props
}) => {
  return <div className={classNames('oejr-bg', `oejr-bg-${type}`, className)} {...props} />;
};
